<template>
<v-container grid-list-md fluid>
  <!-- <v-slide-y-transition mode="out-in"> -->
    <v-layout  row>
      <v-flex md12 >
        <v-card>
          <v-toolbar dense primary-title>
            <v-toolbar-title>{{$t('view.usuario.form.label')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-toolbar>
          <v-slide-y-transition>
            <div v-show="view.elem.showForm">
              <v-card-text>
                <v-form>
                  <v-container>
                    <!-- Skeleton loader -->
                    <v-layout row v-if="view.action.submit.busy">
                      <vue-content-loading :width="450" :height="158">
                        <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                      </vue-content-loading>
                    </v-layout>
                    <v-layout row wrap >
                      <v-flex md6>
                        <v-text-field class="form-group"
                        v-if="!view.action.submit.busy"
                        v-show="view.elem.input.username.visible" 
                        v-model="$v.usuario.username.$model" 
                        :disabled="view.elem.input.username.disabled"
                        :error-messages="getFirstErrorDescription($v.usuario.username)"
                        :label="$t('view.usuario.username.label')" ></v-text-field>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.nombre.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.nombre)"
                        :label="$t('view.usuario.nombre.label')" ></v-text-field>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.telefono.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.telefono)"
                        :label="$t('view.usuario.telefono.label')" ></v-text-field>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.interno.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.interno)"
                        :label="$t('view.usuario.interno.label')" ></v-text-field>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.celular.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.celular)"
                        :label="$t('view.usuario.celular.label')" ></v-text-field>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.correoElectronico.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.correoElectronico)"
                        :label="$t('view.usuario.correoElectronico.label')" ></v-text-field>

                        <v-combobox 
                        v-if="!view.action.submit.busy"
                        v-model="$v.usuario.comercio.$model"
                        :items="view.elem.select.comercios.options"
                        label="Comercio"
                        :error-messages="$t(`validator.${getFirstError($v.usuario.comercio)}.text`,'')"
                        item-text="name"
                        item-value="code"
                        :max-height="200" 
                        multiple    
                        dense  
                        :no-data-text= "$t('view.global.common.no-data-text')"                        
                        clearable
                        deletable-chips
                        small-chips></v-combobox>
                        
                        <v-text-field 
                        v-if="!view.action.submit.busy"
                        v-show="false"
                        v-model="$v.usuario.foto.$model" 
                        :error-messages="getFirstErrorDescription($v.usuario.foto)"
                        :label="$t('view.usuario.foto.label')" ></v-text-field>
                        
                      </v-flex>
                      <v-flex md6 text-xs-center>
                        <div 
                          @mouseover="croppaRemoveBtnShow()"
                          @mouseleave="croppaRemoveBtnHide()">
                          <croppa v-model="croppa"
                            class="userdp"
                            :initial-image="view.croppaInitialImage"
                            :width="150"
                            :height="150"
                            placeholder="Selecciona una imagen"
                            placeholder-color="#000"
                            :placeholder-font-size="10"
                            canvas-color="transparent"
                            :show-loading="true"
                            :loading-size="25"
                            loading-color="#606060"
                            initial-position="center"
                            initial-size="cover"
                            :show-remove-button="false"
                            :prevent-white-space="true"   
                            :loading-end="croppaLoadingEnd()"               
                          ></croppa>
                          <br>
                          <button type="button" 
                            title="Remover imagen"
                            class="btn btn-outline btn-circle btn-primary" 
                            v-show="view.elem.button.removeImg.visible" @click="croppaRemove()"
                            >                         
                            <i class="button__icon icon fa fa-times"></i>
                          </button>
                        </div>
                          
                      </v-flex>
                    </v-layout >
                    <v-layout row>
                      <v-flex md12>
                        <div class="form-group" v-if="!view.action.submit.busy" >
                          <label>{{$t('view.usuario.enabled.label')}}</label>
                            <v-switch v-if="!view.action.submit.busy" input-value="true" color="primary"  :readonly="true" 
                            :label="$v.usuario.enabled.$model ? 'on' : 'off'" v-model="$v.usuario.enabled.$model" ></v-switch>
                        </div>
                      </v-flex >
                      <v-flex md12>

                        <div class="form-group" v-if="!view.action.submit.busy" >
                          <label>{{$t('view.usuario.activo.label')}}</label>
                          <v-switch  input-value="true" color="primary"  :readonly="true" 
                          :label="$v.usuario.activo.$model ? 'on' : 'off'" v-model="$v.usuario.activo.$model" >
                          </v-switch>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="pull-right">
                  <v-tooltip v-show="view.elem.button.enabled.visible 
                  && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')" top>
                    <v-btn 
                      @click="loadPerfiles($v.usuario.username.$model
                      ,$v.usuario.nombre.$model)" 
                      :loading="view.action.submit.busy" 
                      icon 
                      slot="activator" color="primary" large>
                      <v-icon>mdi mdi-account-plus</v-icon>
                    </v-btn>
                    <span>{{$t('view.perfil.form.label')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.enabled.visible 
                  && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')" top>
                    <v-btn 
                      @click="enabledUser()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>mdi mdi-account-off</v-icon>
                    </v-btn>
                    <span>{{enabledTitle}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.resetpassword.visible 
                  && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')" top>
                    <v-btn 
                      @click="askForResetPassword()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>vpn_key</v-icon>
                    </v-btn>
                    <span>{{$t('view.resetPwd.title')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.audit.visible 
                  && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                    <v-btn 
                      @click="showAudit()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>storage</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.auditoria')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.clear.visible 
                  " top>
                    <v-btn 
                      @click="askForClear()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>clear</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.cancel')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.clear.visible 
                  && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')" top>
                    <v-btn 
                      @click="submit()" 
                      :disabled="state.isDisableButtonSubmit()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>check</v-icon>
                    </v-btn>
                    <span>{{submitTitle}}</span>
                  </v-tooltip>
                </div>
              </v-card-actions>
            </div>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
    <data-table ref="usuarioTable" @editRow="loadUsuario" @auditRow="showAudit" @showPerfiles="loadPerfiles"></data-table>      
    <auditoria ref="auditModal"></auditoria>
    <v-layout>
      <!-- Modal -->
      <div id="listUsuarioPerfiles" class="modal" tabindex="-1" role="dialog" aria-hidden="true"> 
        <div class="modal-dialog modal-lg">
          <div class="modal-content animated bounceInRight">
            <div class="modal-header">
              <button id="btnCloseModal" type="button"
                class="btn btn-outline btn-circle btn-lg btn-primary modal-close-sm modal-audit-close modal__close-button"
                data-dismiss="modal" style="width: 54px; height: 54px;">
                <i class="menu-item-icon button__icon icon fa fa-times"></i>
              </button>
              <h2 class="modal-title" style="padding-bottom:16px">{{view.elem.modal.usuarioPerfiles.perfilTitle}}Perfiles Asignados</h2>
              <div class="row" style="padding-top:1em;">
                <div class="col-md-12" style="text-align:right;">
                  <label style="font-weight: normal;">Buscar:<input type="search" class="form-control input-sm modal__search-input" v-model="search" placeholder="" aria-controls="dataTableAudit"></label>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="height:200px; overflow-y: scroll;">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Perfil</th>
                      <th style="text-align:center;">Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in getProfilesFiltered">
                      <td>{{data.group_id}}</td>
                      <td>{{data.group_name}}</td>
                      <td class="text-xs-center" >
                        <v-tooltip top >
                          <v-btn 
                            :loading="data.busy" 
                            @click="perfilAddOrRemove(data)"
                            :color="data.check ? 'primary' : 'green'"
                            fab
                            small
                            dark
                            slot="activator" >
                            <v-icon>{{data.check?'clear':'add'}}</v-icon>
                          </v-btn>
                          <span>{{data.check?'Quitar':'Agregar'}}</span>
                        </v-tooltip>
                        <!-- <v-btn 
                          data-toggle="tooltip" 
                          data-placement="top"
                          v-if="!data.busy" 
                          :title="data.check?'Quitar':'Agregar'"
                          :class="data.check? 'primary':'custom'" 
                          class="privilege__action-button btn-action-edit button button--sacnite button--round-l "
                          @click="perfilAddOrRemove(data)">
                          <i class="button__icon icon fa " :class="[data.check?'fa-times':'fa-plus']"></i>
                          <span>{{data.check?'Quitar':'Agregar'}}</span>
                        </v-btn> -->
                        <!-- <div class="sk-spinner sk-spinner-circle"
                          v-if="data.busy">
                          <div class="sk-circle1 sk-circle"></div>
                          <div class="sk-circle2 sk-circle"></div>
                          <div class="sk-circle3 sk-circle"></div>
                          <div class="sk-circle4 sk-circle"></div>
                          <div class="sk-circle5 sk-circle"></div>
                          <div class="sk-circle6 sk-circle"></div>
                          <div class="sk-circle7 sk-circle"></div>
                          <div class="sk-circle8 sk-circle"></div>
                          <div class="sk-circle9 sk-circle"></div>
                          <div class="sk-circle10 sk-circle"></div>
                          <div class="sk-circle11 sk-circle"></div>
                          <div class="sk-circle12 sk-circle"></div>
                        </div> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <auditoria ref="auditModal"></auditoria>
      <upload-image ref="uploadImage"></upload-image>
    </v-layout>
  <!-- </v-slide-y-transition > -->
</v-container >
</template>
<script>
import {UsuarioModel} from "@/models/seguridad/usuario";
import UsuarioAPI from "@/services/seguridad/usuario";
import CombosAPI from "@/services/catalogos";
import {required, email, maxLength } from "vuelidate/lib/validators";
import {isBooleanValue, alphaNumDot} from '@/helpers/vuelidate/validators'
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/seguridad/usuario/DataTable";
import Auditoria from "@/components/auditoria/Auditoria";
import UploadImage from '@/views/seguridad/usuario/UploadImage';
import Multiselect from 'vue-multiselect';
import tippy from 'tippy.js';
import * as states from '@/views/seguridad/usuario/usuario-states'
import * as R from "ramda";
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';
import {isEmpty} from "@/helpers/validators";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import {scrollToForm} from '@/helpers/form-scroll-to';

let croppa = {};
let croppaInitialImage = '/static/img/user_thumbnail.jpg';

//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus"
      , update:"button__icon icon fa fa-check"
    }
    , data:{
       title:{
        current:"",
        save:"Guardar",
        update:"Actualizar"
       }
    }
  },
  enabled:{
    enable:true
    , visible: false
    , text:""
    , class:{
      current:""
      , enabled:"button__icon icon fa fa-unlock"
      , disabled:"button__icon icon fa fa-lock"
    }
    , data:{
       title:{
        current:"",
        enabled:"Activar",
        disabled:"Desactivar"
       }
    }
  }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
  , resetpassword:{
    visible:false
  }
  , removeImg:{
    visible:false
  }
};
const modal = {
  usuarioPerfiles:{
    htmlElement:undefined
    , modal:undefined
    , perfilTitle:""
  }
};
//Action's state
const action = {
  submit:{
    busy:false
  }
};

const input = {
  username :{
    disabled:true
    , visible: false
  }
}

let select = {
  comercios:{
    options:[{name:'', code:''}]
  }
  // multiListSectores:{
  //   options: [
  //     { name: 'SECTOR 1', code: '1' }
  //     , { name: 'SECTOR 2', code: '2' }
  //   ]
  // }
  // , multiListSectoresAll:{
  //   options:[]
  // }
  // , multiListObrasSociales:{
  //   options: [
  //     { name: 'OBRA SOCIAL 1', code: '1' }
  //     , { name: 'OBRA SOCIAL 2', code: '2' }
  //   ]
  // }
  // , multiListObrasSocialesAll:{
  //   options:[]
  // }
}


export default {
  name: "Usuario",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    return {
      locale: this.$store.language
      , usuario : undefined
      , perfiles:[]
      , state : new Object()
      , search:""
      , view:{
        title:"Usuario"
        , action
        , elem:{
          button
          , select
          , modal
          , input
          , showForm: true
          , croppa
        }
        , croppaInitialImage
      }
    };
  }
  , methods: {
    ...allValidatorMethods
    , getErrorsUsuarios(defaultMessage, message, code){
      return getErrors('Usuarios',defaultMessage, message, code);
    }
    , getBusinessCodeUsuarios(response){
      return getBusinessCode(response);
    }
    , getResponseDTOUsuarios(response){
      return getResponseDTO(response);
    }
    , handleResponse(response){
      const code = this.getBusinessCodeUsuarios(response);
      if(code == 'OK')
      {
        EventBus.$emit(events.MESSAGES, {type:code});
        this.view.croppaInitialImage = this.croppa.value.generateDataUrl();
        let fotoPerfil = response.data.results.usuario.foto;
        try{
          if(this.$store.getters.getUserData.username == response.data.results.usuario.username){
            this.$store.dispatch(actions.USER_SET_FOTO_PERFIL,{fotoPerfil});
          }
        } catch(error){}
        return true;
      }
      else 
      {
        if(response != false)
          EventBus.$emit(events.MESSAGES, {type:'error',message: this.getErrorsUsuarios('Mensaje Default',code)});
          // this.$parent.showToastrError(this.getErrorsUsuarios('Mensaje Default',code),code);
        return false;
      }
    }
    , async submit(){
      try{
        const respuesta = await this.state.submit(this.usuario);
        const responseDTO = this.getResponseDTOUsuarios(respuesta);
        this.handleResponse(respuesta);
        let arrayValues = [];
        if(responseDTO.usuario.comercio != null){
          let comercios = responseDTO.usuario.comercio.split(',');
          this.view.elem.select.comercios.options.forEach(function(option){ 
            if(comercios.includes(option.code+''))
              arrayValues.push({'name':option.name, 'code':option.code});
          });
        }
        responseDTO.usuario.comercio = arrayValues;
        Object.setPrototypeOf(this.state, new states.EditingState(this, responseDTO.usuario));
        this.$refs.uploadImage.imgDataUrl = this.usuario.foto != null && this.usuario.foto != '' ? this.usuario.foto : "/static/img/user_thumbnail.jpg";
      }catch(error){
        console.log(error);
      }
    }
    , async enabledUser(){
      try
      {
        const enabled = !this.usuario.enabled;
        const activo = !this.usuario.enabled;
        const username = this.usuario.username;
        const respuesta = await UsuarioAPI.updateStatus({username, enabled});
        
        if(this.handleResponse(respuesta) == true)
        {
            this.usuario.enabled = enabled;
            this.usuario.activo = activo;
            this.$refs.usuarioTable.refreshData();
            this.initialState();
            Object.setPrototypeOf(this.state, new states.EditingState(this,respuesta.data.results.usuario));
            this.view.elem.button.enabled.data.title.current = this.usuario.enabled ? this.view.elem.button.enabled.data.title.disabled : this.view.elem.button.enabled.data.title.enabled;
        }

      }catch(error){
      }
    }
    , loadImage(){
      var image = new Image()
      // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
      image.setAttribute('crossorigin', 'anonymous');
      image.src = this.usuario.foto;
      
      this.view.croppaInitialImage = this.usuario.foto;

      let orientation = 1
      image.onload = () => {
        this.croppa._onload(image, orientation)
        // this.$emit(events.NEW_IMAGE)
      }

      //this.croppa.refresh();
    }
    , async loadUsuario(username){
      try{
        const response = await UsuarioAPI.get({username});
        const {data:{results:{usuario}}} = response;
        let arrayValues = [];

        if(usuario.comercio != null){
          let comercios = usuario.comercio.split(',');
          this.view.elem.select.comercios.options.forEach(function(option){ 
            if(comercios.includes(option.code+''))
              arrayValues.push({'name':option.name, 'code':option.code});
          });
        }
        usuario.comercio = arrayValues;

        
        Object.setPrototypeOf(this.state, new states.EditingState(this,usuario));
        this.$refs.uploadImage.imgDataUrl = usuario.foto != null && usuario.foto != '' ? usuario.foto : "/static/img/user_thumbnail.jpg";
        
        scrollToForm(this);

        if(response.data.results.usuario.foto){
          this.usuario.foto = usuario.foto;
          this.usuario.foto_miniatura = usuario.foto;
          this.view.croppaInitialImage = usuario.foto;
          this.loadImage();
        }
        else {
          this.usuario.foto = '/static/img/user_thumbnail.jpg';
          this.usuario.foto_miniatura = '/static/img/user_thumbnail.jpg';
          this.view.croppaInitialImage ='/static/img/user_thumbnail.jpg';
          this.loadImage();
        }
        this.view.elem.button.enabled.data.title.current = this.usuario.enabled ? this.view.elem.button.enabled.data.title.disabled : this.view.elem.button.enabled.data.title.enabled;

      }catch(error){
        console.log(error)
      }
    }
    , askForResetPassword(){
      this.state.askForResetPassword(this.usuario.username);
    }
    , askForClear(){
      this.state.askForClear();
    }
    , toggleShow() {
      this.$refs.uploadImage.toggleShow();
    }
    , showImage() {
      try{
        return this.$refs.uploadImage.imgDataUrl;
      } catch(errr){
        return '/static/img/user_thumbnail.jpg';
      }
    }
    , createUsuarioPerfilesModal(){
      this.view.elem.modal.usuarioPerfiles.htmlElement=document.getElementById('listUsuarioPerfiles');
      this.view.elem.modal.usuarioPerfiles.modal = new Modal(
        this.view.elem.modal.usuarioPerfiles.htmlElement
        , {
          keyboard:true
          , backdrop:'static'
        }
      );
    }
    , async loadPerfiles(username, nombre){
      try
      {
        const respuesta = await UsuarioAPI.getPerfiles({username})
        const {data:{results:{perfilesUsuario:data}}}= respuesta;
        this.perfiles = data;
        this.perfiles.forEach(item=>{this.$set(item, 'busy', false)});
        this.view.elem.modal.usuarioPerfiles.perfilTitle = `Usuario: ${nombre} (${username}) - ` || ''
        this.view.elem.modal.usuarioPerfiles.modal.show();
      }
      catch(error)
      {
        console.log(error)
      }
    }
    , async perfilAddOrRemove(perfil){

      if(this.$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD'))
      {
        try{
          let response;
          perfil.busy=true;
          if(perfil.check){
            response = await UsuarioAPI.removePerfil(perfil);
          }else{
            response = await UsuarioAPI.addPerfil(perfil);
          }
          if(response.status==200 &&  response.data.meta.code && response.data.meta.code=="OK")
            perfil.check = !perfil.check;
          setTimeout(()=>{perfil.busy=false},200);
        }catch(error){
          perfil.busy=false;
          console.log(error)
        }
      }
      else
      {
        EventBus.$emit(events.MESSAGES, {type:'error',message: "No tiene permiso para realizar la acción"});
        // this.$parent.showToastrError("No tiene permiso para realizar la acción");
      }
    }
    , async showAudit(id=this.usuario.username,dataDescripcion=this.usuario.nombre){
        this.$refs.auditModal.loadAudit({clave:id,tabla:'Users',descripcion:dataDescripcion,revision:null});
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
    , initialState(){
      Object.setPrototypeOf(this.state, new states.InitialState(this));
    }
    , croppaRemove(){
      try{
        this.view.elem.button.removeImg.visible = false;
        this.croppa.remove();
      } catch(error){}
    }
    , croppaRemoveBtnShow(){
      try{
        if(this.croppa.hasImage())
          this.view.elem.button.removeImg.visible = true;
      } catch(error){}
    }
    , croppaRemoveBtnHide(){
        this.view.elem.button.removeImg.visible = false;
    }
    , croppaLoadingEnd(){
      try{
        if(this.view.croppaInitialImage == undefined)
        {
          this.view.croppaInitialImage = this.croppa.value.generateDataUrl();
        }

        if(this.view.croppaInitialImage != this.croppa.value.generateDataUrl()){
          this.usuario.foto = this.croppa.value.generateDataUrl();
          this.usuario.foto_miniatura = this.croppa.value.generateDataUrl();
          this.view.croppaInitialImage = this.croppa.value.generateDataUrl();
        }
        
      } catch(error){}
    }
    , async loadCombos(){
        const responseCombosComerciosActive = await CombosAPI.get({tipo:'comercios'});
        this.view.elem.select.comercios.options = responseCombosComerciosActive.data.results.combo;
      }
  }
  , computed:{
   submitClass(){
      return this.view.elem.button.submit.class.current
    },
    submitTitle(){
      return this.view.elem.button.submit.data.title.current
    },
    enabledTitle(){
      return this.view.elem.button.enabled.data.title.current
    },
    enabledClass(){
      return this.view.elem.button.enabled.class.current
    }
    , getProfilesFiltered(){
      if(isEmpty(this.search)){
        return this.perfiles
      }else{
        return this.perfiles.filter(perfil=>perfil.group_name.toLowerCase().includes(this.search.toLowerCase()))
      }
    }
    , fotoPerfil() {
      if(isNotEmpty(this.view.croppaInitialImage))
        return this.view.croppaInitialImage;
      
      return '/static/img/user_thumbnail.jpg';
    }
  }
  , validations:{
    usuario:{
      username:{
        required
        , alphaNumDot
        , maxLength : maxLength(50)
      }
      , nombre:{
        required
        , maxLength : maxLength(50)
      }
      , telefono:{
        maxLength : maxLength(80)
      }
      , interno:{
         maxLength : maxLength(80)
      }
      , celular:{
        maxLength : maxLength(80)
      }
      , correoElectronico:{
        required
        , email
        , maxLength : maxLength(80)
      }
      , foto:{
        required
      }
      , enabled: {
        required
      }
      , activo: {
        required
      }
      , comercio:{

      }
    }
    
  }
  , components: {
    VueContentLoading
    , DataTable
    , Auditoria
    // , Multiselect
    , 'upload-image':UploadImage
  }
  // Instance Lifecycle Hooks
  , async created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    this.loadCombos();
  }
  , mounted(){
    this.createUsuarioPerfilesModal()
    // this.$parent.appJQueryConfigMethod();
  },
  updated(){
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal__search-input{
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.userdp {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden; 
  margin: 0 auto;
}
.modal__header{
  height: 50px;
}
.modal__close-button{
  position: absolute;
  right: 0;
  margin-right: 15px;
  width: 54px; 
  height: 54px; 
  border-radius: 27px;
}
.privilege__action-button{
  display:block;
  margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// src/views/seguridad/usuario/Usuario.vue